import {h, Fragment} from "preact"
import { translatedText } from "./utils/translatedText";

export default function PopularSearchQueries() {
  const terms = ['cap', 'overshirt', 'vest', 'suit', 'golfBag']; 

  const handleSearchClick = (term) => {
    const input = document.getElementById('search_input');
  
    if (input) {
      // Set the value as if typed by the user
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      )?.set;
      nativeInputValueSetter?.call(input, term);
  
      // Trigger input event
      const inputEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(inputEvent);
  
      // Focus the input to emulate user interaction
      input.focus();
  
      // Optionally trigger a 'focus' event manually (in case some systems use it)
      const focusEvent = new FocusEvent('focus', { bubbles: true });
      input.dispatchEvent(focusEvent);
    } else {
      console.warn('Search input with id "search_input" not found.');
    }
  };  

  return (
    <>
      <p className="text-13-120--0.5-900 capitalize text-black-55 mb-16 lg:mb-12">
        {translatedText("popularSearches")}
      </p>

      <div className="mb-6">
        {terms.map((term) => (
          <button
            key={term}
            type="button"
            onClick={() => handleSearchClick(term)}
            className="block text-13-120--0.5-700 mb-12 text-black-55"
          >
            {translatedText(term)}
          </button>
        ))}
      </div>
    </>
  );
}
